import QRCodeStyling from 'qr-code-styling';
import { datosAdmin } from './administrador';

export function generarQrCode(){
  const container = document.getElementById('qr-code');
  const containerWidth = container.offsetWidth;
  const qr = new QRCodeStyling({
    width: containerWidth,
    height: containerWidth,
    data: datosAdmin.enlace,
    image: require('../img/img_logo.png'), // Ruta de la imagen a superponer
    margin: 0,
    qrOptions:{
      typeNumber:"7",
      mode:"Byte",
      errorCorrectionLevel:"H"
    },
    imageOptions: {
      crossOrigin: 'anonymous', // Opcional: para permitir el uso de la imagen desde otro dominio
      margin: 0, // Margen alrededor del logotipo
      saveAsBlob: true,
      hideBackgroundDots: false,
      imageSize: 1,
    },
    dotsOptions: {
      type: "dots",
      gradient: {colorStops: [
        {offset: 0, color: 'rgb(0, 0, 0)'},
      ], type: 'linear', rotation: 10},
      roundSize: true
    },
    cornersSquareOptions:{
      type:"extra-rounded",
    },
    cornersDotOptions:{
      type:"dot",
    }
  });

  return qr;
}

export function generarQrCodeMayorCalidad(){
  const qr = new QRCodeStyling({
    width: 800,
    height: 800,
    data: datosAdmin.enlace,
    image: require('../img/img_logo.png'), // Ruta de la imagen a superponer
    margin: 5,
    qrOptions:{
      typeNumber:"7",
      mode:"Byte",
      errorCorrectionLevel:"H"
    },
    imageOptions: {
      crossOrigin: 'anonymous', // Opcional: para permitir el uso de la imagen desde otro dominio
      margin: 0, // Margen alrededor del logotipo
      saveAsBlob: true,
      hideBackgroundDots: false,
      imageSize: 1,
    },
    dotsOptions: {
      type: "dots",
      gradient: {colorStops: [
        {offset: 0, color: 'rgb(0, 0, 0)'},
      ], type: 'linear', rotation: 10},
      roundSize: true
    },
    cornersSquareOptions:{
      type:"extra-rounded",
    },
    cornersDotOptions:{
      type:"dot",
    }
  });

  return qr;
}